import * as React from "react";
import { Button, Typography } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";

export default function ReadMoreButton({ href, onClick }) {
    // si pasas href, se renderiza como <a>; si no, como <button>
    const linkProps = href
        ? { component: "a", href, target: "_blank", rel: "noopener noreferrer" }
        : { onClick };

    return (
        <Button
            {...linkProps}
            variant="contained"
            endIcon={<GitHubIcon sx={{ width: '38px', height: '30px' }} />}
            sx={{
                textTransform: "none",
                fontWeight: 500,
                bgcolor: "#20BC71",
                color: "#000",
                borderRadius: "999px",
                px: 3,
                py: 1.1,
                boxShadow: "none",
                "&:hover": { bgcolor: "#111", boxShadow: "none", color: '#fff' },
                "& .MuiButton-endIcon": { ml: 1 },
                width: '260px',
                height: '50px'
            }}
        >
            <Typography variant="body1">
                Read more
            </Typography>
        </Button>
    );
}
